import { render } from "./GeneralImport.vue?vue&type=template&id=b6b65178"
import script from "./GeneralImport.vue?vue&type=script&lang=js"
export * from "./GeneralImport.vue?vue&type=script&lang=js"

import "./GeneralImport.vue?vue&type=style&index=0&id=b6b65178&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__